import React from 'react';
import { Cog, Brain, RefreshCw } from 'lucide-react';
import ProcessingButton from './ProcessingButton';

const ProcessingControls = ({
  onProcessScrapedFiles,
  onRunPestleAnalysis,
  onReprocessPestleScores,
  onDataRefresh,
  isRefreshing,
  isRunningPestleAnalysis,
  processingStatus
}) => {
  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600 dark:text-gray-400">
        Advanced processing and maintenance operations
      </p>
      
      <div className="grid grid-cols-1 gap-3">
        <ProcessingButton
          onClick={onProcessScrapedFiles}
          disabled={isRefreshing}
          icon={Cog}
          variant="primary"
        >
          Process Scraped Files
        </ProcessingButton>
        
        <ProcessingButton
          onClick={onRunPestleAnalysis}
          disabled={isRunningPestleAnalysis || isRefreshing}
          isLoading={isRunningPestleAnalysis}
          loadingText="Running PESTLE Analysis..."
          icon={Brain}
          variant="warning"
        >
          Run PESTLE Analysis
        </ProcessingButton>
        
        <ProcessingButton
          onClick={onReprocessPestleScores}
          disabled={isRefreshing || isRunningPestleAnalysis}
          icon={RefreshCw}
          variant="purple"
        >
          Reprocess PESTLE Scores
        </ProcessingButton>
        
        <ProcessingButton
          onClick={onDataRefresh}
          disabled={isRefreshing || isRunningPestleAnalysis}
          isLoading={isRefreshing}
          loadingText="Refreshing..."
          icon={RefreshCw}
          variant="success"
        >
          Full Data Refresh
        </ProcessingButton>
      </div>

      {processingStatus && (
        <div className={`p-3 rounded-lg text-sm ${
          processingStatus.includes('Error') 
            ? 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-400'
            : 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400'
        }`}>
          {processingStatus}
        </div>
      )}
    </div>
  );
};

export default ProcessingControls;
